/**
 * @flow
 *
 * @format
 */

export const __DEV__ = false;
export const idRegex = /^([a-z0-9_])+$/;
export const enableHelperLogger = true;
